import React from 'react';
import styles from './styles.module.css';
import Text from 'components/shared/Text';
import { appStoreBadge, playStoreBadge } from 'assets/icons';
import { useContext } from 'react';
import MobileContext from 'context/MobileContext';
import { roundLogo } from 'assets/logos';

const RedirectionPage = () => {
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : null;
  const lineBreak = isMobile ? <br /> : null;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.imgContainer}>
          <img src={roundLogo} alt="" className={styles.logoImage} />
        </div>
        <Text className={`${styles.heading} ${mobClassName}`}>
          For the Full Digital Experience, {lineBreak} download the FITNESS SF App!
        </Text>
        <div className={`${styles.imgContainer} ${mobClassName}`}>
          <div className={styles.imgSubContainer1}>
            <a
              href="https://apps.apple.com/us/app/fitness-sf/id1484657961"
              target="_blank"
            >
              <img alt="" className={styles.img} src={appStoreBadge} />
            </a>
          </div>
          <div className={styles.imgSubContainer2}>
            <a
              href="https://play.google.com/store/apps/details?id=com.follow.fitnesssf3&hl=en"
              target="_blank"
            >
              <img alt="" className={styles.img} src={playStoreBadge} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedirectionPage;
